module.exports = function UpdateSourceState(state) {
    this.state = state;
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/topic-update/update-source-state.js
// module id = 507
// module chunks = 0